import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Anchor, Text} from "@mantine/core";
import {Link} from "react-router-dom";
import {Order} from "../types.ts";
import {OrderStatusBadge} from "../profile/OrderStatusBadge.tsx";
import {formatTimestamp, TIMESTAMP_PLACEHOLDER} from "../../../utils/TableTimestamps.tsx";

// Every column is sortable (§3a). The `accessor` is what sorts: ids and status as strings,
// `created` as an ISO-8601 string, nulls last in both directions (shared sortRecords). Empty
// values render the shared placeholder (§13). Opening an order for edit is the table's
// onRowClick, gated on UpdateOrder there, not a link drawn in a cell.
export const useOrdersTableColumns = () => {

    const columns: DataTableColumn<Order>[] = [
        {
            accessor: 'id',
            title: I18n.get('Order ID'),
            sortable: true,
            render: (record: Order) => <Text size="sm" ff="monospace">{record.id}</Text>,
        },
        {
            accessor: 'subscriptionId',
            title: I18n.get('Subscription ID'),
            sortable: true,
            render: (record: Order) => record.subscriptionId ? (
                // The subscription detail route is customer-subscriptions/:id. The old
                // /customers/:cid/subscriptions/:sid target matched no route. The click must
                // not also open the row's edit drawer.
                <Anchor
                    component={Link}
                    to={`/customer-subscriptions/${record.subscriptionId}`}
                    size="sm"
                    ff="monospace"
                    onClick={(event) => event.stopPropagation()}
                >
                    {record.subscriptionId}
                </Anchor>
            ) : TIMESTAMP_PLACEHOLDER,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            sortable: true,
            render: (record: Order) => <OrderStatusBadge status={record.status}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            sortable: true,
            render: (record: Order) => formatTimestamp(record.created),
        },
    ];

    return {
        columns,
    };
};
